export default "__VITE_ASSET__1b9038b2__"